export const topics = [
  {
    slug: 'data-breach',
    name: '数据泄露',
    shortName: '数据泄露',
    icon: 'ri-database-2-line',
    color: 'primary',
    summary: '用户账号、手机号、地址等敏感信息被批量外泄，往往牵出转卖与二次诈骗。',
    description:
      '数据泄露指平台在存储、传输或权限管理环节出现疏漏，导致用户数据库被批量窃取或被内部人员违规导出。泄露数据一旦流入黑市，常被用于撞库登录、精准诈骗与骚扰营销。判断风险时，重点看平台的加密方式、日志留存与事后通报态度。',
    image:
      'https://readdy.ai/api/search-image?query=Abstract%20dark%20red%20digital%20data%20streams%20flowing%20out%20of%20a%20glowing%20server%20rack%20concept%2C%20editorial%20illustration%2C%20moody%20teal%20and%20amber%20accents%2C%20clean%20minimal%20composition&width=1200&height=800&seq=topic-breach-01&orientation=landscape',
  },
  {
    slug: 'vulnerability',
    name: '安全漏洞',
    shortName: '安全漏洞',
    icon: 'ri-bug-line',
    color: 'accent',
    summary: '接口越权、逻辑缺陷、老旧组件未修补，攻击者无需密码即可读取或篡改数据。',
    description:
      '安全漏洞并不总是「被攻破」，更多时候是接口鉴权缺失导致的越权访问。常见类型包括失效的访问控制、注入漏洞、不安全的直接对象引用以及长期未修复的第三方组件风险。企业是否建立漏洞响应流程，是评估其安全水位的关键指标。',
    image:
      'https://readdy.ai/api/search-image?query=Stylized%20abstract%20illustration%20of%20a%20broken%20circuit%20board%20with%20amber%20warning%20glow%2C%20dark%20editorial%20tech%20art%2C%20minimal%20clean%20background%20with%20warm%20rust%20tones&width=1200&height=800&seq=topic-bug-01&orientation=landscape',
  },
  {
    slug: 'fraud',
    name: '盗刷与诈骗',
    shortName: '盗刷诈骗',
    icon: 'ri-bank-card-line',
    color: 'primary',
    summary: '免密支付、代扣协议与虚假客服来电，是资金被盗刷最常见的两条路径。',
    description:
      '盗刷与诈骗类事件通常表现为支付被重复扣款、代扣协议被默认勾选、退款流程被伪装成「客服指导」。核心风险点在于平台的支付授权管理与风控策略，以及用户对陌生链接、远程控制类话术的识别能力。',
    image:
      'https://readdy.ai/api/search-image?query=Abstract%20concept%20art%20of%20a%20cracked%20bank%20card%20with%20amber%20warning%20light%2C%20dark%20editorial%20illustration%2C%20minimal%20rust%20and%20teal%20color%20palette%2C%20clean%20background&width=1200&height=800&seq=topic-fraud-01&orientation=landscape',
  },
  {
    slug: 'privacy',
    name: '隐私风险',
    shortName: '隐私风险',
    icon: 'ri-eye-off-line',
    color: 'secondary',
    summary: '通讯录、剪贴板、位置与相册权限被过度索取，隐私在不知不觉中被收集。',
    description:
      '隐私风险关注的是「合法但你不想要」的数据收集行为：超范围索取权限、默认开启个性化追踪、拒绝授权就无法使用核心功能。这类风险不会立刻造成损失，却会在长期积累后形成难以撤回的数字画像。',
    image:
      'https://readdy.ai/api/search-image?query=Conceptual%20illustration%20of%20a%20single%20eye%20watching%20abstract%20data%20particles%2C%20muted%20teal%20and%20warm%20neutral%20palette%2C%20editorial%20minimal%20style%2C%20clean%20background&width=1200&height=800&seq=topic-privacy-01&orientation=landscape',
  },
  {
    slug: 'illegal-collection',
    name: '违规收集使用',
    shortName: '违规收集',
    icon: 'ri-file-warning-line',
    color: 'accent',
    summary: '未经同意共享给第三方、强制索权、超期存储，都属于典型的违规处理行为。',
    description:
      '违规收集使用个人信息涵盖未明示目的、未取得单独同意、超期保存、违规共享给合作方等行为。此类问题通常由监管通报或专项检查发现，对平台的合规能力提出直接质疑。',
    image:
      'https://readdy.ai/api/search-image?query=Abstract%20editorial%20illustration%20of%20documents%20and%20lock%20icons%20being%20scanned%2C%20amber%20and%20neutral%20warm%20tones%2C%20minimal%20clean%20composition%2C%20professional%20style&width=1200&height=800&seq=topic-collection-01&orientation=landscape',
  },
  {
    slug: 'penalty',
    name: '监管处罚',
    shortName: '监管处罚',
    icon: 'ri-scales-3-line',
    color: 'secondary',
    summary: '通报、约谈、下架、罚款，监管记录是判断平台合规态度的硬证据。',
    description:
      '监管处罚记录包括公开通报、限期整改、应用下架与行政处罚。相比厂商的自我声明，处罚与通报来自第三方视角，更接近平台真实的合规水位，也是本站在整理事件时优先引用的信息类型。',
    image:
      'https://readdy.ai/api/search-image?query=Editorial%20illustration%20of%20classic%20scales%20of%20justice%20with%20subtle%20digital%20grid%2C%20muted%20teal%20and%20warm%20beige%20palette%2C%20minimal%20clean%20background%2C%20serious%20professional%20tone&width=1200&height=800&seq=topic-penalty-01&orientation=landscape',
  },
];

export type Topic = typeof topics[number];